const URBANEASE_URL = process.env.REACT_APP_URBANEASE_URL!;

export const goToUrbanease = () => {
  window.location.href = URBANEASE_URL;
};

export const queriesParser = (): UrlQueries => {
  let queries: UrlQueries = null;
  const values =
    window.location?.search
      ?.slice(1)
      ?.split('&')
      ?.map((m) => m.split('=')) ?? null;

  if (values) {
    // parse queries
    queries = {};

    values.forEach((e) => {
      if (queries) {
        if (e[0] === 'token_password') queries.token = e[1];
        if (e[0] === 'email') queries.email = e[1];
      }
    });

    if (queries.email && queries.token) return queries;

    return null;
  }

  return null;
};

/**
 * Filters an array by removing duplicates.
 * @param array - The input array to filter.
 * @returns A new array without duplicates.
 */
export function removeDuplicates<T>(array: T[]): T[] {
  return Array.from(new Set(array));
}
